// Accepting App component because Profile Card is deprecated and will be replaced in future
import { ProfileCustomValuesList } from "PFApp/components/custom_values_list";
import { Stack } from "PFComponents/containers/flex";
import { Typography } from "PFComponents/typography";
import { getAttribute } from "PFCore/helpers/get_attribute";
import { ActivityPureCustomValue, MatchCustomValue, MatchedProfile, PureCustomValue } from "PFTypes";
import { CSSProperties, useMemo } from "react";
import { useTranslation } from "react-i18next";

const SKILLS_LIMIT = 5;

type ProfileCardSkillsProps = {
  style?: CSSProperties;
  profileResponse: MatchedProfile;
  isUnbiasedMode?: boolean;
};

const ProfileCardSkills = ({ style, profileResponse, isUnbiasedMode }: ProfileCardSkillsProps) => {
  const { t } = useTranslation("core", { keyPrefix: "profileCardSkills" });
  const { profile } = profileResponse;

  const matchingSkills = getAttribute(profileResponse, "customValues");
  const { direct, indirect, related } = { direct: [], indirect: [], related: [], ...matchingSkills };

  // response from matches endpoint
  const data = useMemo(() => {
    if (direct.length || related.length || indirect.length) {
      return [
        {
          header: t("matchingAttributes"),
          skillsToShow: direct.map((item) => ({ ...item, ...item?.customValue }))
        },
        {
          header: t("relatedAttributes"),
          skillsToShow: related.map((item) => ({ ...item, ...item?.customValue }))
        },
        {
          header: t("indirectAttributes"),
          skillsToShow: indirect.map((item) => ({ ...item, ...item?.customValue }))
        }
      ].filter((row) => row.skillsToShow?.length);
    }

    // response from profiles endoint
    const skills = profile.skills || [];
    const topSkills = skills.filter(({ top }) => top);
    const isTopSkills = topSkills.length > 0;
    const skillsToShow = isTopSkills ? topSkills : skills;
    if (!skillsToShow.length) {
      return [];
    }
    return [
      {
        header: isTopSkills ? t("coreSkills") : t("skills"),
        skillsToShow
      }
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileResponse, t]);

  if (!data.length) {
    return null;
  }

  return (
    <Stack style={style}>
      {data.map(({ skillsToShow, header }) => (
        <Stack key={header} columnGap="spacingLg">
          <Typography variant="labelRegular">{header}</Typography>
          {skillsToShow.length > 0 && (
            <ProfileCustomValuesList
              customFieldName="skills"
              customValues={skillsToShow as (MatchCustomValue | ActivityPureCustomValue | PureCustomValue)[]}
              profileId={profile?.id}
              limit={SKILLS_LIMIT}
              isUnbiasedMode={isUnbiasedMode}
            />
          )}
        </Stack>
      ))}
    </Stack>
  );
};

export default ProfileCardSkills;
